import { useTranslation } from "@/shared/providers/LanguageProvider";
import { analyticsStats } from "../data";

export function AnalyticsStatsRow() {
  const { t } = useTranslation();

  return (
    <div className="col-span-full grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {analyticsStats.map((stat) => (
        <div key={stat.id} className={`card-shadow rounded-2xl ${stat.bg} p-5`}>
          <p className="text-sm font-medium text-muted-foreground">{t.analytics.stats[stat.id]}</p>
          <p className="mt-2 text-2xl font-bold text-foreground">{stat.value}</p>
          <p className={`mt-1 text-xs font-medium ${stat.color}`}>{stat.change}</p>
        </div>
      ))}
    </div>
  );
}
